export class ValidationHub {
    constructor() {
        this.inputs = {};
    }
    register(id, input) {
        if (input && id && input.validate) {
            this.inputs[id] = input;
        }
    }
    unregister(id) {
        if (id) {
            delete this.inputs[id];
        }
    }
    validate() {
        const validationResults = [];
        for (const id in this.inputs) {
            if (this.inputs.hasOwnProperty(id)) {
                const input = this.inputs[id];
                if (input) {
                    input.validate();
                }
                if (input.validationResult && input.validationResult.hasError) {
                    validationResults.push({ id, validationResult: input.validationResult });
                }
            }
        }
        if (validationResults.length > 0) {
            return validationResults;
        }
        return null;
    }
    clearValidation() {
        for (const id in this.inputs) {
            if (this.inputs.hasOwnProperty(id)) {
                const input = this.inputs[id];
                if (input) {
                    input.clearValidation();
                }
            }
        }
        return null;
    }
}
